<template>
  <ion-header class="ion-no-border">
    <ion-toolbar class="-not-fixed">
      <ion-buttons slot="start">
        <ion-button
          @click="activePage > 1 ? activePage-- : modalController.dismiss()"
        >
          <ion-icon
            :src="require('@lib/assets/icons/icon_zurueck.svg')"
            slot="start"
          ></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content ref="content" class="ion-padding">
    <ion-grid fixed>
      <template v-if="activePage === 1">
        <div class="ion-text-center u-color-primary">
          <roodie :expression="'happy'" />
          <p>
            <b>So einfach geht's</b>
          </p>
          <p>
            Signieren Sie die Teilnahmeerklärung für Ihr Coaching digital oder
            händisch. Senden Sie diese über die Roodie ARAG App oder per Post
            direkt an MedicalContact.
          </p>
        </div>
        <ol class="c-timeline">
          <li>
            Prüfen Sie bitte Ihre Kontaktdaten und wählen Sie Ihr Coaching
            Programm aus.
          </li>
          <li>
            Sie erhalten eine Nachricht mit Ihrer Teilnahmeerklärung. Drucken
            Sie diese bitte aus.
          </li>
          <li>
            Befüllen Sie bitte die restlichen Felder und unterschreiben Sie das
            Formular.
          </li>
          <li>
            Laden Sie die Teilnahmeerklärung über "+" in der Roodie.App hoch in
            Ihren Roodie.Safe und teilen Sie diese mit Medical Contact.
          </li>
        </ol>
        <div class="u-color-primary">
          <ion-icon :src="require('@lib/assets/icons/info.svg')" />&nbsp;<b
            >Hinweis:</b
          >
          <div>
            Sie können die Teilnahmeerklärung auch per Post an Medical Contact
            senden: MedicalContact AG, Postfach 102652, 45128 Essen
          </div>
        </div>
        <div class="ion-text-center">
          <ion-button
            @click="activePage = 2"
            class="ion-margin-top"
            fill="outline"
            >Weiter</ion-button
          >
        </div>
      </template>
      <template v-else-if="activePage === 2">
        <div class="ion-text-center">
          <roodie :expression="'happy'" />
          <p>
            <!-- Rufen Sie gebührenfrei
            <a href="tel:+498941248300" class="gtm-call-medicalcontact"
              ><u>089 4124-8300</u></a
            > -->
            Geben Sie hier Ihren Wunsch für die Teilnahme am Coaching an:
          </p>
        </div>
        <ion-row>
          <ion-col size="6">
            <ion-item lines="none">
              <ion-label position="stacked">Anrede</ion-label>
              <ion-select
                v-model="formInput['Initials']"
                placeholder="Frau/Herr"
                cancel-text="Abbrechen"
              >
                <ion-select-option value="F">Frau</ion-select-option>
                <ion-select-option value="M">Herr</ion-select-option>
              </ion-select>
            </ion-item>
            <input-error id="Initials" />
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" size-md="6">
            <ion-item lines="none">
              <ion-label position="stacked">Vorname</ion-label>
              <ion-input v-model="formInput['Firstname']"></ion-input>
            </ion-item>
            <input-error id="Firstname" />
          </ion-col>
          <ion-col size="12" size-md="6">
            <ion-item lines="none">
              <ion-label position="stacked">Nachname</ion-label>
              <ion-input v-model="formInput['Lastname']"></ion-input>
            </ion-item>
            <input-error id="Lastname" />
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" size-md>
            <ion-item lines="none">
              <ion-label position="stacked">Geburtsdatum</ion-label>
              <!-- <ion-datetime
              v-if="isPlatform('mobile')"
              cancel-text="Abbrechen"
              done-text="Fertig"
              displayFormat="DD.MM.YYYY"
              pickerFormat="DD.MM.YYYY"
              placeholder="TT.MM.JJJJ"
              v-model="formInput['BirthDate']"
              @ionFocus="
                if (formInput['BirthDate'] === '')
                  formInput['BirthDate'] = '1990-01-01';
              "
            ></ion-datetime> -->
              <ion-input
                v-imask="{
                  mask: Date,
                }"
                :value="formInput['BirthDate']"
                placeholder="TT.MM.JJJJ"
                @accept="imaskOnAccept($event, 'BirthDate')"
                @complete="imaskOnComplete"
                @ionChange="imaskOnChange($event, 'BirthDate')"
              >
              </ion-input>
            </ion-item>
            <input-error id="BirthDate" />
          </ion-col>
          <ion-col size="12" size-md>
            <ion-item lines="none">
              <ion-label position="stacked">Versicherungsnummer</ion-label>
              <ion-input
                placeholder=""
                v-model="formInput['ExternalId']"
              ></ion-input>
            </ion-item>
            <ion-row class="ion-margin-top">
              <ion-col size="auto">
                <ion-icon
                  :src="require('@lib/assets/icons/info.svg')"
                ></ion-icon>
              </ion-col>
              <ion-col>
                <ion-text color="primary" class="u-xsmall">
                  Ihre Versicherungsnummer finden Sie auf den Briefen der ARAG
                  Versicherung immer direkt beim
                  <a
                    href="#"
                    @click.prevent="$store.commit('setShowPolicyNumber', true)"
                    ><u>Betreff</u></a
                  >. Oder gehen Sie in der ARAG Gesundheits-App dazu einfach im
                  Menü auf "Mein Profil“.
                </ion-text>
              </ion-col>
            </ion-row>
            <input-error id="ExternalId" />
          </ion-col>
        </ion-row>
        <div class="c-line"></div>
        <ion-list lines="none">
          <ion-radio-group v-model="formInput.Condition">
            <!-- <ion-list-header> -->
            <h6>Für welche Erkrankung möchten Sie ein Coaching?</h6>
            <!-- </ion-list-header> -->
            <ion-item>
              <ion-label color="primary">Herzerkrankung</ion-label>
              <ion-radio slot="start" value="Herzerkrankung"></ion-radio>
            </ion-item>
            <ion-item>
              <ion-label color="primary">Diabetes II</ion-label>
              <ion-radio slot="start" value="Diabetes II"></ion-radio>
            </ion-item>
            <ion-item>
              <ion-label color="primary">Beides</ion-label>
              <ion-radio
                slot="start"
                value="Herzerkrankung und Diabetes II"
              ></ion-radio>
            </ion-item>
          </ion-radio-group>
        </ion-list>
        <ion-item lines="none">
          <ion-label position="stacked">E-Mail Adresse</ion-label>
          <ion-input
            placeholder="adresse@mail.com"
            v-model="formInput['Email']"
            type="email"
          ></ion-input>
        </ion-item>
        <input-error id="Email" />
        <ion-item lines="none">
          <ion-label position="stacked">Mobilnummer</ion-label>
          <ion-input
            placeholder="+49XXXXXXXXXX"
            v-model="formInput['Msisdn']"
          ></ion-input>
        </ion-item>
        <input-error id="Msisdn" />
        <PrivacyBetterDoc
          @checked="
            isPrivacyChecked = true;
            formInput.Privacy1Label = $event?.privacy1Label;
            formInput.Privacy2Label = $event?.privacy2Label;
          "
          @unchecked="isPrivacyChecked = false"
          :routing="formInput.Routing"
          :showShouldSave="false"
          from="contact"
        />
        <!-- <PrivacyArag
        @checked="
          isPrivacyChecked = true;
          formInput.Privacy1Label = $event?.privacy1Label;
          formInput.Privacy2Label = $event?.privacy2Label;
        "
        @unchecked="isPrivacyChecked = false"
      /> -->
        <!-- <ion-item lines="none" class="ion-margin-top">
        <ion-checkbox slot="start" v-model="formInput.Privacy1"></ion-checkbox>
        <ion-label class="ion-text-wrap" color="primary">
          Ja, ich möchte eine Teilnahmeerklärung bei der ARAG anfordern, um ein
          Coaching von MedicalContact in Anspruch zu nehmen und stimme der
          <u
            ><a href="#" @click.prevent="openInfoModal(privacy1Text)"
              >Verarbeitung meiner personenbezogenen Daten
            </a></u
          >
          durch die ARAG zu.
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-checkbox slot="start" v-model="formInput.Privacy2"></ion-checkbox>
        <ion-label class="ion-text-wrap" color="primary">
          Ich suche Unterstützung für mein gesundheitliches Anliegen und/oder
          Hilfe bei der Suche nach passenden Gesundheitsdienstleistern und
          stimme zu diesem Zweck der Entbindung von der ärztlichen
          Schweigepflicht der ARAG Krankenversicherungs-AG zu und akzeptiere die
          <u
            ><a
              href="https://www.arag.de/datenschutzerklaerung/"
              target="_blank"
              >Datenschutzbestimmungen</a
            ></u
          >.
        </ion-label>
      </ion-item> -->
        <div class="c-line"></div>
        <!-- <ion-row>
        <ion-col size="8" size-md>
          <ion-item lines="none">
            <ion-label position="stacked">Straße</ion-label>
            <ion-input v-model="formInput['Street']"></ion-input>
          </ion-item>
          <input-error id="Street" />
        </ion-col>
        <ion-col size="4" size-md>
          <ion-item lines="none">
            <ion-label position="stacked">Hausnr.</ion-label>
            <ion-input v-model="formInput['Housenumber']"></ion-input>
          </ion-item>
          <input-error id="Housenumber" />
        </ion-col>
      </ion-row>
      <ion-row align-items-center>
        <ion-col size="12" size-md>
          <ion-item lines="none">
            <ion-label position="stacked">Stiege/Tür</ion-label>
            <ion-input v-model="formInput['xxxxxxxxxxx']"></ion-input>
          </ion-item>
        </ion-col>
        <ion-col size="4" size-md>
          <ion-item lines="none">
            <ion-label position="stacked">PLZ</ion-label>
            <ion-input type="number" v-model="formInput['Zip']"></ion-input>
          </ion-item>
          <input-error id="Zip" />
        </ion-col>
        <ion-col size="8" size-md>
          <ion-item lines="none">
            <ion-label position="stacked">Ort</ion-label>
            <ion-input v-model="formInput['Country']"></ion-input>
          </ion-item>
          <input-error id="Country" />
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size-md>
          <ion-item lines="none">
            <ion-label position="stacked">Land</ion-label>
            <ion-select
              v-model="formInput['Land']"
              cancel-text="Abbrechen"
              disabled
            >
              <ion-select-option>Deutschland</ion-select-option>
              <ion-select-option>Länderliste fehlt</ion-select-option>
            </ion-select>
          </ion-item>
          <input-error id="Land" />
        </ion-col>
      </ion-row> -->
        <!-- <div class="c-line"></div> -->
        <ion-item lines="none" class="ion-margin-bottom">
          <ion-label position="stacked">Notiz</ion-label>
          <ion-textarea rows="5" v-model="formInput.Note"></ion-textarea>
        </ion-item>
        <ion-button
          @click="submit"
          class="ion-margin-top gtm-participation-medicalcontact"
          fill="outline"
          :disabled="!isPrivacyChecked"
          >Absenden</ion-button
        >
        <!-- <ion-row class="c-help ion-margin-top ion-padding-top">
        <ion-col size="auto">
          <ion-icon :src="require('@lib/assets/icons/info.svg')" />
        </ion-col>
        <ion-col>
          Das Angebot von MedicalContact ist eine Zusatzleistung des
          Kooperationspartners. Sie kann jederzeit entfallen, wenn die
          Kooperation endet.
        </ion-col>
      </ion-row> -->
      </template>
    </ion-grid>
  </ion-content>
  <ion-modal
    :is-open="showEnd"
    @willDismiss="modalInstance.dismiss({ isSubmitted: true })"
  >
    <ion-page>
      <ion-header class="ion-no-border">
        <ion-toolbar color="primary" class="-not-fixed">
          <ion-button
            @click="$store.commit('setOpenMenu', true)"
            slot="end"
            fill="clear"
            size="large"
            class="ion-hide-md-up"
            ><ion-icon
              slot="icon-only"
              :src="require('@lib/assets/icons/menu-white.svg')"
              size="large"
            ></ion-icon
          ></ion-button>
        </ion-toolbar>
      </ion-header>
      <ion-content
        ref="content"
        style="--background: var(--ion-color-primary); --color: white"
      >
        <ion-grid
          class="ion-padding"
          style="display: flex; flex-direction: column; min-height: 100%"
        >
          <ion-row
            style="flex-grow: 1"
            class="ion-text-center ion-align-items-center"
          >
            <ion-col size="12">
              <ion-icon
                :src="require('@lib/assets/icons/roodie-white.svg')"
                size="large"
                color="light"
              />
              <h2>
                Sie erhalten in Kürze eine Nachricht von uns mit Ihrer
                Teilnahmeerklärung.
              </h2>
              <p>
                Unterzeichnen Sie die Teilnahmeerklärung für Ihr Coaching gleich
                digital oder händisch. Senden Sie diese anschließend über die
                Roodie ARAG App oder per Post direkt an MedicalContact.
              </p>
              <div class="ion-padding-top">
                <img
                  width="50"
                  src="@lib/assets/icons/white/notification.svg"
                />
              </div>
              <p>
                Ihr persönlicher Coach von MedicalContact ruft Sie dann in Kürze
                an. Er führt mit Ihnen ein Aufnahmegespräch für das Programm und
                erstellt mit Ihnen gemeinsam die Inhalte Ihres Coachings.
              </p>
              <!-- <div class="ion-padding-top">
                <ion-icon
                  :src="require('@lib/assets/icons/icon_schrittzaehler.svg')"
                  size="large"
                  color="light"></ion-icon>
                <ion-icon
                  :src="require('@lib/assets/icons/icon_blutzucker.svg')"
                  size="large"
                  color="light"></ion-icon>
                <ion-icon
                  :src="
                    require('@lib/assets/icons/icon_blutdruckmessgeraet.svg')
                  "
                  size="large"
                  color="light"></ion-icon>
              </div>
              <p>
                Auch medizinische Hilfsmittel wie Schrittzähler, Blutzucker-
                oder Blutdruckmessgerät werden Ihnen bei Bedarf kostenlos zur
                Verfügung gestellt.
              </p> -->
            </ion-col>
            <ion-col size="12">
              <ion-button @click="showEnd = false" color="light" fill="outline">
                Beenden
              </ion-button>
            </ion-col>
          </ion-row>
          <branding style="margin-top: auto" />
        </ion-grid>
      </ion-content>
    </ion-page>
  </ion-modal>
</template>

<script>
import {
  IonItem,
  IonLabel,
  IonContent,
  IonRadioGroup,
  IonRadio,
  IonList,
  // IonListHeader,
  // IonCheckbox,
  IonTextarea,
  IonButton,
  IonIcon,
  IonRow,
  IonCol,
  IonHeader,
  IonToolbar,
  IonButtons,
  modalController,
  IonGrid,
  IonSelect,
  IonSelectOption,
  IonInput,
  // IonDatetime,
  IonModal,
  IonPage,
  IonText,
} from "@ionic/vue";
import Roodie from "@lib/components/svg/Roodie";
import { chevronBack, helpCircle } from "ionicons/icons";
import InputError from "@/components/InputError";
import { isPlatform } from "@ionic/vue";
import InfoModal from "@lib/components/InfoModal";
import { apiGetUser } from "@/api/user";
import Branding from "@/components/Branding";
import { IMaskDirective } from "vue-imask";
import { imask } from "@/mixins/imask";
import { contact } from "@/api/contact";
// import PrivacyArag from "@/components/PrivacyArag";
import PrivacyBetterDoc from "@/components/PrivacyBetterDoc";

export default {
  directives: {
    imask: IMaskDirective,
  },
  mixins: [imask],
  components: {
    IonItem,
    IonLabel,
    Roodie,
    IonContent,
    IonRadioGroup,
    IonRadio,
    IonList,
    // IonListHeader,
    // IonCheckbox,
    IonTextarea,
    IonButton,
    IonIcon,
    IonRow,
    IonCol,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonGrid,
    IonSelect,
    IonSelectOption,
    IonInput,
    InputError,
    // IonDatetime,
    IonModal,
    IonPage,
    IonText,
    Branding,
    // PrivacyArag,
    PrivacyBetterDoc,
  },
  props: {
    from: {
      required: false,
      type: String,
      default: "",
    },
  },
  data() {
    return {
      activePage: 1,
      formInput: {
        Routing: "MedicalContact",
        Reference: "Kunde fordert Coaching Teilnahmeerklärung an",
        Initials: "",
        Firstname: "",
        Lastname: "",
        BirthDate: "",
        ExternalId: "",
        Condition: "Herzerkrankung",
        Msisdn: "",
        Privacy1: false,
        Privacy2: false,
        Street: "",
        Housenumber: "",
        Zip: "",
        City: "",
        Country: "Deutschland",
        Note: "",
        Email: "",
        Privacy1Label: "",
        Privacy2Label: "",
        AragPartner: "MedicalContact",
        // Privacy1Label:
        //   "Ja, ich möchte eine Teilnahmeerklärung bei der ARAG anfordern, um ein Coaching von MedicalContact in Anspruch zu nehmen und stimme der Verarbeitung meiner personenbezogenen Daten durch die ARAG zu.",
        // Privacy2Label:
        //   "Ich suche Unterstützung für mein gesundheitliches Anliegen und/oder Hilfe bei der Suche nach passenden Gesundheitsdienstleistern und stimme zu diesem Zweck der Entbindung von der ärztlichen Schweigepflicht der ARAG Krankenversicherungs-AG zu und akzeptiere die Datenschutzbestimmungen.",
      },
      modalController: modalController,
      showEnd: false,
      isPrivacyChecked: false,
      modalInstance: null,
      // privacy1: false,
      // privacy1Text:
      //   // "<p>Ihre angegebenen Daten (Anrede, Vorname, Nachname, Versicherungsnummer) werden im Zuge der Vertragserfüllung an die ARAG weitergegeben. Die Rechtsgrundlage iSd Datenschutz-Grundverordnung (DSGVO) ist hierbei Art 6 Abs 1 lit b DSGVO.</p><p>Die an die ARAG übermittelten Daten werden ausschließlich zu Zwecken der Erstellung Ihrer Teilnahmeerklärung verarbeitet, die Sie für die Inanspruchnahme eines Coachings von Medical Contact berechtigt. Sie können jederzeit die Kontaktaufnahme untersagen (Widerrufsmöglichkeit der Einwilligung gemäß Art 7 Abs.3 DSGVO).</p>",
      //   "<p>Die Angaben zu Ihren Symptomen, Vorname, Nachname, Alter und Geschlecht, Telefonnummer, Information zur ARAG-Krankenversicherung und die Vertragsdaten (E-Mail-Adresse, Passwort, Vorname, Nachname und Adresse) werden von Roodie an die ARAG Krankenversicherungs-AG GmbH zum Zweck der Unterstützung für mein gesundheitliches Anliegen und/oder Suche nach Gesundheitsdienstleistern weitergegeben und von dieser ausschließlich zu diesem Zweck verarbeitet und genutzt. Ferner werden bei Vereinbarung eines Arzt-/Kliniktermins die Daten des behandelnden Gesundheitsdienstleistern (Vorname, Nachname, Fachrichtung), Zeitpunkt und Ort des Termins von der ARAG Krankenversicherungs-AG an Roodie übermittelt, um diese Informationen in meinem Konto in der Roodie ARAG App zu speichern. Diese Einwilligung kann von mir jederzeit widerrufen werden.</p><p>Es handelt sich dabei um personenbezogene Daten, die sich auf Ihre körperliche oder mentale Gesundheit, einschließlich der Erbringung von Gesundheitsdienstleistungen beziehen und aus denen Informationen über Ihren Gesundheitszustand hervorgehen. Rechtsgrundlage für die Verarbeitung dieser Daten ist Ihre Einwilligung gemäß Art 9 Abs 2 lit a DSGVO.</p>",
    };
  },
  async mounted() {
    console.log(this);
    apiGetUser().then(() => {
      this.formInput.Initials = this.$store.state.user.Initials;
      this.formInput.Firstname = this.$store.state.user.FirstName;
      this.formInput.Lastname = this.$store.state.user.LastName;
      this.formInput.BirthDate = this.$store.state.user.BirthDate.split("-")
        .reverse()
        .join(".");
      this.formInput.ExternalId = this.$store.state.user.ExternalId;
      this.formInput.Email = this.$store.state.user.Email;
      this.formInput.Msisdn = this.$store.state.user.Msisdn;
    });
    this.modalInstance = await modalController.getTop();
  },
  methods: {
    async submit() {
      this.$store.commit("setShowLoading", true);
      const contactData = {
        ...this.formInput,
        Privacy1: this.isPrivacyChecked,
        Privacy2: this.isPrivacyChecked,
      };
      const contactResponse = await contact(contactData);
      if (contactResponse.data.Status === "Success") {
        this.showEnd = true;
      }
    },
    async openInfoModal(text) {
      const modal = await modalController.create({
        component: InfoModal,
        cssClass: "my-custom-class",
        componentProps: {
          title: "Datenschutzbestimmungen",
          text: text,
        },
      });
      return modal.present();
    },
    // closeEndModal() {
    //   this.showEnd = false;
    //   // if (this.from === "answerSummary") {
    //   this.$nextTick(() => {
    //     modalController.dismiss({ isSubmitted: true });
    //   });
    //   // }
    // },
  },
  setup() {
    return { chevronBack, isPlatform, helpCircle };
  },
};
</script>

<style lang="scss" scoped>
.c-timeline {
  background: var(--ion-color-medium);
  border-radius: var(--gangl-border-radius);
  padding: 20px;
  list-style: none;
  color: var(--ion-color-primary);
  text-align: center;
  counter-reset: numbered-list;
  margin: 20px 0;

  li {
    &:before {
      content: counter(numbered-list, decimal);
      counter-increment: numbered-list;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: var(--ion-color-primary);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 20px;
      margin: 10px auto;
    }
    &:not(:last-child):after {
      content: "";
      width: 0px;
      height: 20px;
      display: block;
      border: 1px solid var(--ion-color-primary);
      margin: 10px auto;
    }
  }
}
</style>
